module.exports = __webpack_public_path__ + "img/videobj.ad6f472e.png";